import { Component, Input, ViewEncapsulation } from '@angular/core';

/**
 * This component is used to add app wide loading effect
 * using white backdrop and spinner.
 * This component is added into app-component.
 *
 * @export
 */
@Component({
  /* tslint:disable-next-line */
  selector: 'ngx-backdrop',
  templateUrl: './ng-backdrop.component.html',
  styleUrls: ['./ng-backdrop.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NgBackdropComponent {

  @Input() spinner: string; // Type of spinner to be used.
  @Input() text: string; // If any text to be displayed on spinner.
  @Input() backdropClass: string; // Any class given to backdrop.
  @Input() textClass: string; // Any class to given to loader text.

  private timerRef: any;
  isVisible = false;

  constructor() { }

  /**
   * Show method shows spinner.
   *
   * @param [thershold] If provided there will be given delay in hiding the spinner.
   * @returns Promis which resolves when spinner is hidden
   */
  show(thershold?: number): Promise<null> {
    return new Promise((resolve) => {
      if (thershold) {
        this.timerRef = setTimeout(() => {
          this.isVisible = true;
          resolve(null);
        }, thershold);
      } else {
        this.isVisible = true;
        resolve(null);
      }
    });
  }

  /**
   * This function hides the spinner. If any timeOut was active it will clear it first.
   */
  hide() {
    if (this.timerRef) {
      clearInterval(this.timerRef);
    }
    this.isVisible = false;
  }
}
